import apiClient from '../api-client';
import type { ModelWithVersions, CreateModelRequest, UpdateModelRequest, PaginatedResponse, PaginationParams } from '@geely/shared';

export const modelsApi = {
  list: () =>
    apiClient.get<ModelWithVersions[]>('/models'),

  listPaginated: (params: PaginationParams) =>
    apiClient.get<PaginatedResponse<ModelWithVersions>>('/models', { params }),

  getById: (id: string) =>
    apiClient.get<ModelWithVersions>(`/models/${id}`),

  create: (data: CreateModelRequest) =>
    apiClient.post<ModelWithVersions>('/models', data),

  update: (id: string, data: UpdateModelRequest) =>
    apiClient.patch<ModelWithVersions>(`/models/${id}`, data),

  delete: (id: string) =>
    apiClient.delete(`/models/${id}`),
};
